<div class="p-grid pageBody">
  <div class="p-col-12 p-lg-12 p-md-12 p-sm-12">
    <div class="title">{{ 'TERMS_N_CONDITIONS_HEAD' | translate }}</div>
    <div class="discalimerSection">
      <p [innerHTML]="getTranslatedText('TERMS_N_CONDITIONS_PARA_1')"></p>
      <p [innerHTML]="getTranslatedText('TERMS_N_CONDITIONS_PARA_2')"></p>
    </div>
  </div>
</div>
